import { useMemo, useEffect } from "react";
import { Dropdown } from "colbi_web_ui/lib/components/inputs";
import { SovosBox, SovosFormControlLabel, SovosIcon, SovosRadio, SovosRadioGroup, SovosTooltip } from "mosaic-react";

const JANUARY_MONTH_NUMBER = 1;
const YEAR_SHIFT_NO_OFFSET = "0";

export const BuildFiscalYearOffsetComponent = (props) => {
    const { styles, i18n, availableMonthsArray, fiscalYearStartMonth = null, yearShift = null, handleChange, yearShiftArray } = props || {};

    const selectedMonth = useMemo(() => {
        return availableMonthsArray.find(({ id: month }) => month === fiscalYearStartMonth) || [];
    }, [availableMonthsArray, fiscalYearStartMonth]);


    const { calendarFiscalYear, firstMonthDayYear } = useMemo(() => {

        if (!fiscalYearStartMonth || yearShift === null || yearShift === undefined) {
            return { calendarFiscalYear: '', firstMonthDayYear: '' };
        }

        const dateNow = new Date();
        const calendarFiscalYear = (dateNow.getFullYear() + +yearShift).toString();
        const month = fiscalYearStartMonth - 1;
        const date = new Date(calendarFiscalYear, month, 1);
        const fiscalYearStart = date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
        const firstMonthDayYear = fiscalYearStart.match(/^([A-Za-z]+) /)?.[1] || '';

        return { calendarFiscalYear, firstMonthDayYear };
    }, [fiscalYearStartMonth, yearShift]);


    useEffect(() => {
        if (fiscalYearStartMonth === JANUARY_MONTH_NUMBER && yearShift !== YEAR_SHIFT_NO_OFFSET) {
            handleChange(null, "yearShift", YEAR_SHIFT_NO_OFFSET);
        }
    }, [fiscalYearStartMonth, yearShift, handleChange]);

    return (
        <div>
            <div className={styles["group-content"]}>
                <h5 children={i18n`fiscal_year_config`} className={styles["main-title"]} />
                <SovosBox className={styles["title-info"]}>
                    <h5 children={i18n`fiscal_year_start_month`} />
                    <SovosTooltip title={i18n`fiscal_year_start_month_info`} children={<SovosIcon children={"info"} />} />
                </SovosBox>
                <Dropdown
                    className={styles["dropdown"]}
                    value={selectedMonth}
                    options={availableMonthsArray || []}
                    placeholder={i18n`fiscal_year_start_month_placeholder`}
                    filter
                    onChange={(e) => {
                        handleChange(e, "fiscalYearStartMonth", e.target.value.id);
                    }}
                />
            </div>
            <div className={styles["group-content"]}>
                <h5 children={i18n`year_shift_offset`} className={styles["main-title"]} />
                <SovosBox className={styles["title-info"]}>
                    <h5 children={i18n`year_shift_offset_select`} />
                    <SovosTooltip title={i18n`year_shift_offset_info`} children={<SovosIcon children={"info"} />} />
                </SovosBox>
                <SovosRadioGroup
                    row
                    value={yearShift || 0}
                    onChange={(e) => {
                        handleChange(e, "yearShift", e.target.value)
                    }}
                    sx={{ display: "flex", gap: "10px" }}
                >
                    {(yearShiftArray || []).map(({ label, value, description }) => {
                        return (
                            <SovosBox className={styles["item-entry"]}>
                                <SovosFormControlLabel
                                    key={value}
                                    value={value}
                                    disabled={value !== YEAR_SHIFT_NO_OFFSET && fiscalYearStartMonth === JANUARY_MONTH_NUMBER}
                                    control={<SovosRadio />}
                                    label={label}
                                />
                                <SovosBox sx={{ display: "flex", lineBreak: "loose" }}>{i18n`${description}`}</SovosBox>
                            </SovosBox>
                        )
                    })}
                </SovosRadioGroup>
            </div>
            {yearShift !== null && yearShift !== undefined && fiscalYearStartMonth ? (
                <BuildFiscalYearShiftOffsetComponent
                    styles={styles}
                    i18n={i18n}
                    firstMonthDayYear={firstMonthDayYear}
                    calendarFiscalYear={calendarFiscalYear}
                />
            ) : null}
        </div>
    )
}

export const BuildFiscalYearShiftOffsetComponent = (props) => {
    const { styles, i18n, firstMonthDayYear, calendarFiscalYear } = props || {};
    return (
        <SovosBox className={styles["item-entry"]} sx={{ backgroundColor: "#ECF6FF" }}>
            <SovosBox>
                <SovosBox className={styles["title-info"]}>
                    <SovosTooltip style={{ color: "#2D50D9" }} children={<SovosIcon children={"info_outlined"} />} />
                    <h5 style={{ color: "#2D50D9", fontWeight: 'bold' }} className={styles["info-main-title"]} children={i18n`fiscal_year_preview ${calendarFiscalYear}`} />
                </SovosBox>
                <SovosBox>
                    <SovosBox className={styles["fiscal-year-entry"]}>
                        <h5 style={{ color: "#2D50D9" }} children={`${i18n`fiscal_year_start`}: `} />
                        <h5 style={{ fontWeight: 'normal', color: "#2D50D9" }} children={i18n`${firstMonthDayYear} 1, ${calendarFiscalYear}`} />
                    </SovosBox>
                    <SovosBox className={styles["fiscal-year-entry"]}>
                        <h5 style={{ color: "#2D50D9" }} children={`${i18n`year_designation`}: `} />
                        <h5 style={{ fontWeight: 'normal', color: "#2D50D9" }} children={i18n`FY ${calendarFiscalYear}`} />
                    </SovosBox>
                    <SovosBox className={styles["fiscal-year-entry"]}>
                        <h5 style={{ color: "#2D50D9" }} children={`${i18n`example`}: `} />
                        <h5 style={{ fontWeight: 'normal', color: "#2D50D9" }} children={i18n`A transaction on ${firstMonthDayYear} 1, ${calendarFiscalYear} belongs to FY ${calendarFiscalYear}`} />
                    </SovosBox>
                </SovosBox>
            </SovosBox>
        </SovosBox>
    )
}